var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"title":"Sandbox","page-info":{},"breadcrumbs":[]}},[_c('SiloAllocationStateAnalysis')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }